import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { ExportDef } from '@cobliteam/ui-business/components/DataTable';
import { associationSourceLabel, sourceFromIdentificationMethod } from '@cobliteam/ui-business/components/MultiSelects/MultiSelectAssociationSource/MultiSelectAssociationSource';
import { format, formatDuration, intervalToDuration } from '@cobliteam/utils/date';

const exportDef = (title: string): ExportDef<Path> => ({
  title,
  fileName: 'trechos-frota',
  data: [
    {
      id: 'startTime',
      columnName: 'Início',
      row: (row) => format(row.startTime, 'dd/MM/yyyy, HH:mm'),
    },
    {
      id: 'endTime',
      columnName: 'Fim',
      row: (row) => format(row.endTime, 'dd/MM/yyyy, HH:mm'),
    },
    {
      id: 'type',
      columnName: 'Tipo',
      row: (row) => (row.type === 'trip' ? 'Em movimento' : 'Parado'),
    },
    {
      id: 'duration',
      columnName: 'Duração',
      row: (row) => formatDuration(intervalToDuration({ start: new Date(row.startTime), end: new Date(row.endTime) })),
    },
    {
      id: 'driver',
      columnName: 'Motorista associado',
      row: (row) => row.driver?.name || 'Não associado',
    },
    {
      id: 'associationMethod',
      columnName: 'Método de associação',
      row: (row) => (row.associationSource && associationSourceLabel[sourceFromIdentificationMethod(row.associationSource)]) || '--',
    },
  ],
});

export default exportDef;
